export const events = [];
const MAXIMUM_WAITING_TIME = 5 * 1000;
const MAXIMUM_LOGGED_EVENTS = 10;
let timer = null;
export const transportOptions = {
  maxWaitingTime: MAXIMUM_WAITING_TIME,
  maxLoggedEvents: MAXIMUM_LOGGED_EVENTS
};
export function createTransport(api, options) {
  Object.assign(transportOptions, {
    ...options,
    api
  });
  return {
    sendOnExit,
    emit
  };
}
function nextTime(callback) {
  return (window.requestIdleCallback || window.requestAnimationFrame || (cb => setTimeout(cb, 17)))(callback);
}
function emit() {
  clearTimeout(timer);
  events.length > transportOptions.maxLoggedEvents ? send() : timer = setTimeout(send, transportOptions.maxWaitingTime);
}
function send() {
  if (events.length === 0) {
    return;
  }
  const transportEvents = events.splice(0, transportOptions.maxLoggedEvents);
  const transportData = buildTransportData(transportEvents);
  sendBeacon(transportOptions.api, transportData);
  events.length && nextTime(send);
}
function sendBeacon(requestUrl, data) {
  const headers = {
    type: "application/json"
  };
  const blob = new Blob([JSON.stringify(data)], headers);
  window.navigator.sendBeacon(requestUrl, blob);
}
function sendOnExit() {
  window.addEventListener("beforeunload", send, false);
}
function buildTransportData(data) {
  return {
    model: "easyops.FRONTEND_STAT",
    columns: ["_ver", "st", "et", "lt", "size", "time", "traceId", "code", "duration", "page", "uid", "username", "api", "type", "msg", "status", "pageId", "route", "apiCount", "maxApiTimeCost", "apiSizeCost", "pageTitle"],
    data
  };
}
//# sourceMappingURL=transport.js.map